/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Nav_PricingInputs */

const en_platform_nav_pricing = /** @type {(inputs: Platform_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const pl_platform_nav_pricing = /** @type {(inputs: Platform_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennik`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Platform_Nav_PricingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_nav_pricing = /** @type {((inputs?: Platform_Nav_PricingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Nav_PricingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_nav_pricing(inputs)
	return en_platform_nav_pricing(inputs)
});